<template>
    <div v-show="visible">
        <label>
            {{ t(displayName) }}
        </label>
        <input type="checkbox" v-model="value" class="form-control boolean-component" @change="onInputChange">
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        config: {
            type: Object,
            default: () => {
                return {
                    name: null,
                    value: null,
                    display: true,
                    position: 0,
                    visible: true,
                    displayName: null
                };
            }
        },
        eventBus: {
            Type: Object,
        },
        queryParams: {
            Type: Object
        },
        routeParams: {
            Type: Object
        },
        onChange: {
            Type: Function,
        },
        onDefaultValueSet: {
            Type: Function,
        },
    },
    data() {
        return {
            displayName: null,
            visible: true,
            value: null,
            name: null,
        };
    },
    mounted() {
        this.init();
        this.$parent.$on(`${this.name}-set-value`, (filterState) => {
            this.setValue(filterState);
        });
        this.setDefaultValue(this.queryParams[this.name] || this.config.value);
    },
    computed: {
    },
    methods: {
        init() {
            this.displayName = this.config.displayName;
            this.visible = this.config.visible;
            this.name = this.config.name;
        },
        onInputChange() {
            this.onChange(this.name, this.value);
        },
        setDefaultValue(value) {
            this.setValue(value);
            this.onDefaultValueSet(this.name, this.value);
        },
        setValue(value) {
            if (value === null) {
                this.value = null;

                return;
            }

            this.value = value;
        }
    }
}

</script>

<style scoped>
.boolean-component {
    width: 45px!important;
    margin-top: 0!important;
    margin-left: -5px!important;
}
</style>


// WEBPACK FOOTER //
// BooleanComponent.vue?fae027c8